module.exports = __webpack_public_path__ + "img/Bookmark-Spanish-Logo-250-minuscom.e8f560bc.png";